import * as React from 'react';
export const klarnaSvg = React.forwardRef(function klarnaSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M6.852 2c0 2.205-1 4.228-2.748 5.549l-1.05.8 4.085 5.628h3.356l-3.76-5.18C8.519 7.003 9.515 4.592 9.515 2zM0 2h2.8v11.977H0zm10.921 10.443c0-.859.69-1.556 1.54-1.556.85 0 1.539.697 1.539 1.556S13.31 14 12.46 14c-.85 0-1.539-.697-1.539-1.557z',
    }),
  );
});
klarnaSvg.defaultProps = {
  height: '16',
  viewBox: '0 0 14 16',
  width: '14',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var klarna = {
  category: 'paymentmethod',
  colorable: true,
  name: 'klarna',
  svg: klarnaSvg,
};
